var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"16","height":"16","rx":"8","fill":"#F7C800","key":0}),React.createElement("path",{"d":"M6.86343 10.9961C6.70335 10.9961 6.55128 10.9291 6.43922 10.8119L4.17409 8.4429C3.94197 8.20014 3.94197 7.79833 4.17409 7.55556C4.4062 7.3128 4.7904 7.3128 5.02251 7.55556L6.86343 9.48092L10.9775 5.17817C11.2096 4.9354 11.5938 4.9354 11.8259 5.17817C12.058 5.42093 12.058 5.82274 11.8259 6.0655L7.28764 10.8119C7.17559 10.9291 7.02351 10.9961 6.86343 10.9961Z","fill":"white","key":1})]);
}

Check.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Check;

Check.default = Check;
